import request from "./request";
// 首页
export function homeModuleInfo(params) {
  return request({
    url: '/fe/pageModule/moduleInfo',
    method: "get",
    params
  });
}

export function aboutModuleInfo(params) {
  return request({
    url: '/fe/pageModule/moduleInfo',
    method: "get",
    params
  });
}


export function bannerInfo(params) {
  return request({
    url: '/fe/banner/info',
    method: "get",
    params
  });
}

export function personsList(params) {
  return request({
    url: '/fe/cms/persons/list',
    method: "get",
    params
  });
}
// SEO接口
export function seoModuleInfo(params) {
  return request({
    url: '/fe/pageModule/moduleInfo',
    method: "get",
    params
  });
}

// 留言
export function messageSubmit(data) {
  return request({
    url: '/fe/customer/message/submit',
    method: "post",
    data
  });
}


//产品分类详情查询（单个，包含推荐产品信息)
export function catgoryCodes(params) {
  let catgoryCodes = params.categoryId
  return request({
    url: `/fe/product/category/${catgoryCodes}`,
    method: "get",
    params
  });
}

// 产品分类
export function getCategories(params) {
  return request({
    url: '/fe/product/categories',
    method: "get",
    params
  });
}

// 分类下产品查询
export function productList(params) {
  return request({
    url: '/fe/product/list',
    method: "get",
    params
  });
}

// 产品查询
export function productQuery(params) {
  return request({
    url: '/fe/product/query',
    method: "get",
    params
  });
}

// 产品总文档查询
export function categoryDocuments(params) {
  return request({
    url: '/fe/product/category/documents',
    method: "get",
    params
  });
}

// 常见问题查询
export function cmsFaqs(params) {
  return request({
    url: '/fe/cms/faqs',
    method: "get",
    params
  });
}

//首页内容获取(栏目推荐内容)
export function catgoryRecommend(params) {
  let catgoryCodes = params.catgoryCodes
  return request({
    url: `/fe/cms/${catgoryCodes}/recommend`,
    method: "get",
    params
  });
}

// 栏目内容查询
export function cmsList(params) {
  return request({
    url: '/fe/cms/list',
    method: "get",
    params
  });
}


// 获取内容详情
export function cmsQuery(params) {
  return request({
    url: '/fe/cms/query',
    method: "get",
    params
  });
}

// 获取内容详情
export function hotrecommend(params) {
  return request({
    url: '/fe/product/recommend',
    method: "get",
    params
  });
}

// 产品搜索
export function productSearch(params) {
  return request({
    url: '/fe/product/search',
    method: "get",
    params
  });
}

// 地图配置
export function mapConfig(params) {
  return request({
    url: '/fe/map/config',
    method: "get",
    params
  });
}

// 首页产品分类推荐
export function recommendhome(params) {
  return request({
    url: '/fe/product/category/recommend/home',
    method: "get",
    params
  });
}